import { useQueryClient } from "@tanstack/react-query";
import { useOptimisticUpdateMutation } from "../../../hooks/useOptimisticUpdateMutation";
import ComponentsService from "../../../services/ComponentsService";

import {
  IUpdateComponentTemplateCommand,
  PaginatedListOfComponentTemplateDto,
} from "@growth-machine-llc/stridist-api-client";
import { COMPONENT_TEMPLATE_QUERY_KEY } from "../../component-template/ComponentTemplateDialog";
import { COMPONENT_TEMPLATES_LIBRARY_QUERY_KEY } from "../ComponentTemplateLibrary";

export const useUpdateLibraryComponentTemplate = (templateId: string) => {
  const queryClient = useQueryClient();

  return useOptimisticUpdateMutation({
    successToastMessage: "Template updated.",
    queryKey: [COMPONENT_TEMPLATES_LIBRARY_QUERY_KEY],
    exactQueryKey: false,
    mutationFn: ComponentsService.updateComponentTemplate,
    optimisticUpdater: {
      updateFn: (
        oldData: PaginatedListOfComponentTemplateDto,
        variables: IUpdateComponentTemplateCommand,
      ) => {
        return {
          ...oldData,
          items: oldData.items.map((item) =>
            item.id === variables.id
              ? {
                  ...item,
                  ...variables,
                }
              : item,
          ),
        } as PaginatedListOfComponentTemplateDto;
      },
    },
    options: {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [COMPONENT_TEMPLATE_QUERY_KEY, { templateId }],
          exact: true,
        });
      },
    },
  });
};
